// @ts-nocheck
export const localeCodes =  [
  "fa",
  "en"
]
export const localeLoaders = {
  fa: [
    {
      key: "locale_fa_46json_ad67b1c8",
      load: () => import("#nuxt-i18n/ad67b1c8" /* webpackChunkName: "locale_fa_46json_ad67b1c8" */),
      cache: true
    }
  ],
  en: [
    {
      key: "locale_en_46json_2f3fc6f3",
      load: () => import("#nuxt-i18n/2f3fc6f3" /* webpackChunkName: "locale_en_46json_2f3fc6f3" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "fa",
    name: "فا",
    dir: "rtl",
    slug: "persian",
    language: undefined
  },
  {
    code: "en",
    name: "en",
    dir: "ltr",
    slug: "english",
    language: undefined
  }
]
/** client **/

/** client-end **/